// src/services/quotations.js

const API_BASE = 'https://new.sbdemolition.online/api/quotations';

async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('authToken');
  
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` }),
      ...options.headers
    }
  });

  if (response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Network error' }));
    throw new Error(error.error || error.message || `API Error ${response.status}`);
  }

  return response.json();
}

export const quotationsAPI = {
  // ✅ FIX: استخدم query parameter بدل path
  list: (projectId) => {
    return apiRequest(`/list.php?projectId=${projectId}`);
  },
  
  create: (data) => apiRequest('/create.php', {
    method: 'POST',
    body: JSON.stringify(data)
  }),
  
  // ✅ FIX: استخدم query parameter
  update: (id, data) => apiRequest(`/update.php?id=${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  }),
  
  // ✅ FIX: استخدم query parameter
  delete: (id) => apiRequest(`/delete.php?id=${id}`, {
    method: 'DELETE'
  }),
  
  uploadFile: async (file) => {
    const token = localStorage.getItem('authToken');
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE}/upload-file.php`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      body: formData
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Upload failed' }));
      throw new Error(error.error || 'File upload failed');
    }

    return response.json();
  },

  deleteFile: (fileName) => apiRequest('/delete-file.php', {
    method: 'POST',
    body: JSON.stringify({ fileName })
  }),

  generateToken: (quotationId) => apiRequest('/generate-token.php', {
    method: 'POST',
    body: JSON.stringify({ quotationId })
  })
};
